var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEp2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9627 18.9192C29.0383 16.9462 31.1418 14.5813 31.1418 11.4867C31.1418 9.51546 30.3346 7.62498 28.8977 6.23112C27.4609 4.83726 25.5121 4.0542 23.4801 4.0542C21.0284 4.0542 19.3011 4.72988 17.2115 6.75692C15.122 4.72988 13.3946 4.0542 10.9429 4.0542C8.9109 4.0542 6.96213 4.83726 5.52529 6.23112C4.08846 7.62498 3.28125 9.51546 3.28125 11.4867C3.28125 14.5948 5.37079 16.9597 7.46033 18.9192L17.2115 28.3787L26.9627 18.9192Z",
    stroke: "#C49A6C",
    strokeWidth: 2.78605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2118 6.75684L13.0885 10.7569C12.8055 11.0294 12.5808 11.3537 12.4275 11.7108C12.2742 12.068 12.1953 12.4511 12.1953 12.838C12.1953 13.2248 12.2742 13.6079 12.4275 13.9651C12.5808 14.3223 12.8055 14.6465 13.0885 14.919C14.2308 16.0272 16.0556 16.0677 17.2676 15.0136L20.1511 12.4461C20.8739 11.8098 21.8149 11.4574 22.7909 11.4574C23.7669 11.4574 24.7079 11.8098 25.4307 12.4461L29.5541 16.0407",
    stroke: "#C49A6C",
    strokeWidth: 2.78605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5712 20.2706L22.7852 17.5679",
    stroke: "#C49A6C",
    strokeWidth: 2.78605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3915 24.3243L18.6055 21.6216",
    stroke: "#C49A6C",
    strokeWidth: 2.78605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEp2);
export default __webpack_public_path__ + "static/media/EP2.94b6924f9034282d7880546eb520a6f4.svg";
export { ForwardRef as ReactComponent };